<script lang="ts">
  import { globalCurrencyTag } from '../../../common/util';
  import Text from '../../common/components/Text.svelte';
  import { ServiceProduct } from '../mapper/home-maintenance.mapper';
  import { cityUnavailable } from '../store/home_maintenance_store';
  import HMVipDiscountCard from './HMVipDiscountCard.svelte';

  export let service: ServiceProduct;

  export let isSaved: boolean;

  export let isVipMember: boolean;

  export let editService: () => void;
</script>

<div class="price-details">
  <div class="current-price">
    <Text
      key="jood.price.with.currency"
      args={[
        globalCurrencyTag,
        `${isVipMember ? service?.product?.homeMaintenanceVipData?.vipPrice?.formattedValue : service?.price}`,
      ]}
    />
    {#if isSaved && !$cityUnavailable && service?.displayType?.length > 0}
      <div>
        <!-- svelte-ignore a11y-click-events-have-key-events -->
        <span class="c_icon_new c_icon_new--write edit-inline-btn" on:click={editService}></span>
      </div>
    {/if}
  </div>
  <HMVipDiscountCard {service} {isVipMember} />
</div>
